// extracted by css-extract-rspack-plugin
export default {"filterButton":"XbKtu","StyledParametersList":"eShfV","ParametersListContainer":"YNTEq","isSmallScreen":"sEHrU","isShowingMobile":"lpYXK"};